import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router'

@Component({
  selector: 'app-fund-list',
  templateUrl: './fund-list.component.html',
  styleUrls: ['./fund-list.component.scss']
})
export class FundListComponent implements OnInit {

  language = JSON.parse(localStorage.getItem('language'))

  @Input()
  header: string

  @Input()
  description: string

  @Input()
  fundList = []

  @Input()
  currentPage

  @Input()
  totalPage

  @Output()
  currentPageChange = new EventEmitter()

  disableIcon: boolean = false

  constructor(private router: Router) {


  }

  ngOnInit() {
  }



  setCurrentPage(event) {
    this.currentPageChange.emit(event)
  }

}
